<template>
  <div v-if="isSupported">
    <p class="txt-bold txt-red fs-md-5 mt-4 mb-0">
      Send USDT ({{ networkType }}) only to this address!
    </p>
    <div>
      <img
        :src="qrImage"
        alt="qr-code"
        style="max-width: 220px"
      />
    </div>
    <textarea
      :ref="networkType.toLowerCase()"
      readonly
      class="w-100 form-control"
      :value="walletAddress"
    ></textarea>
    <p class="txt-bold fs-md-6" v-if="amount">
      Total Transfer: ${{ amount }}
    </p>
    <button
      class="btn btn-blue txt-bold"
      @click="copyWalletAddress"
    >
      Copy Wallet Address
    </button>
  </div>
</template>

<script>
import Notiflix from "notiflix";

export default {
  name: "CryptoWallet",
  props: {
    networkType: {
      type: String,
      required: true
    },
    walletAddress: {
      type: String,
      required: true
    },
    qrImage: {
      type: String,
      required: true
    },
    supportedNetworks: {
      type: Array,
      default: () => []
    },
    amount: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    isSupported() {
      console.log("DEBUG CryptoWallet - networkType:", this.networkType);
      console.log("DEBUG CryptoWallet - supportedNetworks:", this.supportedNetworks);
      console.log("DEBUG CryptoWallet - includes result:", this.supportedNetworks.includes(this.networkType));
      return this.supportedNetworks.includes(this.networkType);
    }
  },
  methods: {
    async copyWalletAddress() {
      try {
        const textArea = this.$refs[this.networkType.toLowerCase()];
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(this.walletAddress);
        } else {
          // Fallback for older browsers
          textArea.select();
          document.execCommand("copy");
        }
        Notiflix.Notify.success("Copied Successfully");
      } catch (err) {
        console.error("Failed to copy: ", err);
        Notiflix.Notify.failure("Copy failed");
      }
    }
  }
};
</script>